import { render, staticRenderFns } from "./GptConcept.vue?vue&type=template&id=986f9a72&scoped=true"
import script from "./GptConcept.vue?vue&type=script&lang=js"
export * from "./GptConcept.vue?vue&type=script&lang=js"
import style0 from "./GptConcept.vue?vue&type=style&index=0&id=986f9a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986f9a72",
  null
  
)

export default component.exports